import { createNullableContext } from '~/common/contexts/nullableContext';
import { StepComponentsContextType } from './types/StepComponentsContextType';

export const StepComponentsContext =
  createNullableContext<StepComponentsContextType>();
